import { config } from 'state/product/config'
import { createImage } from 'state/product/fns/createImage'
import { createSwatch } from 'state/product/fns/createSwatch'

export const createDOMNodes = (product, color) => {
  let nodes = {
    image: createImage(product, color),
    swatch: createSwatch(product, color)
  }

  // Initialize new DOM nodes
  for (let [nodeName, node] of Object.entries(config.nodes.instance)) {
    nodes[nodeName] = node.cloneNode(false)
  }

  nodes.imageLink.href = color.url.product
  nodes.imageLink.title = product.name
  nodes.link.href = color.url.product

  if (product.is.onSale) {
    nodes.salePrice.innerText = product.salePrice
    nodes.price.className = 'strike'
    nodes.price.setAttribute('aria-label', 'Regular price')
    nodes.salePrice.setAttribute('aria-label', 'Sale price');
    nodes.price.setAttribute('sale-price', product.salePrice)
    nodes.price.setAttribute('regular-price', product.price)
    nodes.priceContainer.appendChild(nodes.price)
    nodes.priceContainer.appendChild(nodes.salePrice)
  } else {
    nodes.priceContainer.appendChild(nodes.price)
  }

  nodes.price.innerHTML = product.price
  nodes.title.innerHTML = product.name

  // Rating & Review Count
  nodes.rating.dataset.rating = product.rating
  nodes.rating.dataset.count = product.reviewCount


  // Object.assign(nodes.swatchContainer, {
  // className: 'swatchImages'
  // })
  // <ul class="swatchImages" data-count="{{ product.colors | size }}" aria-label="{{ product.colors | size }} colors">

  nodes.container.appendChild(nodes.span)
  nodes.span.appendChild(nodes.imageLink)
  nodes.imageLink.appendChild(nodes.image)
  nodes.imageLink.appendChild(nodes.title)
  nodes.imageLink.appendChild(nodes.priceContainer)
  nodes.imageLink.appendChild(nodes.rating)
  nodes.imageLink.appendChild(nodes.swatchContainer)

  return nodes
}
